import React from 'react';
import { useAuth } from '../auth/AuthContext';
import { Navigate } from 'react-router-dom';

const LoginPage = () => {
  const { authenticated, login, register } = useAuth();

  if (authenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="container">
      <div className="row justify-content-center align-items-center vh-100">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow">
            <div className="card-body p-5">
              <h2 className="text-center mb-4">MagisPrev</h2>
              <p className="text-center text-muted mb-4">
                Sistema de Calculos Previdenciarios
              </p>

              <div className="d-grid gap-3">
                <button className="btn btn-primary btn-lg" onClick={login}>
                  Entrar
                </button>
                <button className="btn btn-outline-secondary" onClick={register}>
                  Criar Conta
                </button>
              </div>

              <hr className="my-4" />

              <p className="text-center text-muted small">
                O acesso ao sistema requer autorizacao previa.
                <br />
                Entre em contato com o administrador para solicitar acesso.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
